/**
 * Check if a user has admin role based on Clerk metadata
 *
 * Admin users are identified by:
 * 1. Email: uk@health.org (hardcoded admin email)
 * 2. Public metadata role: 'admin'
 *
 * @param {Object} user - Clerk user object
 * @returns {boolean} - True if user is admin
 */
export const isAdmin = (user) => {
  if (!user) return false;

  // Check if user email is admin email
  const primaryEmail = user.primaryEmailAddress?.emailAddress;
  if (primaryEmail === 'uk@health.org') {
    return true;
  }

  // Check if user has admin role in public metadata
  const role = user.publicMetadata?.role;
  if (role === 'admin') {
    return true;
  }

  return false;
};

/**
 * Get user display name from Clerk user object
 * @param {Object} user - Clerk user object
 * @returns {string} - User display name
 */
export const getUserDisplayName = (user) => {
  if (!user) return 'User';

  return user.fullName || user.firstName || user.username || 'User';
};

/**
 * Get user email from Clerk user object
 * @param {Object} user - Clerk user object
 * @returns {string} - User email
 */
export const getUserEmail = (user) => {
  if (!user) return '';

  return user.primaryEmailAddress?.emailAddress || '';
};
